import { __rest } from "tslib";
import React from 'react';
import { cn } from './utils';
const Table = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("table", Object.assign({ ref: ref, className: cn('table-fixed caption-bottom text-sm', className) }, props)));
});
Table.displayName = 'Table';
const TableHeader = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("thead", Object.assign({ ref: ref, className: cn('[&_tr]:border-b', className) }, props)));
});
TableHeader.displayName = 'TableHeader';
const TableBody = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("tbody", Object.assign({ ref: ref, className: cn('[&_tr:last-child]:border-0', className) }, props)));
});
TableBody.displayName = 'TableBody';
const TableFooter = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("tfoot", Object.assign({ ref: ref, className: cn('bg-primary text-primary-foreground font-medium', className) }, props)));
});
TableFooter.displayName = 'TableFooter';
const TableRow = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("tr", Object.assign({ ref: ref, className: cn('hover:bg-muted/50 data-[state=selected]:bg-muted border-b transition-colors', className) }, props)));
});
TableRow.displayName = 'TableRow';
const TableHead = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("th", Object.assign({ ref: ref, className: cn('text-muted-foreground h-12 px-4 text-left align-middle font-medium [&:has([role=checkbox])]:pr-0', className) }, props)));
});
TableHead.displayName = 'TableHead';
const TableCell = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("td", Object.assign({ ref: ref, className: cn('p-4 align-middle [&:has([role=checkbox])]:pr-0', className) }, props)));
});
TableCell.displayName = 'TableCell';
const TableCaption = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("caption", Object.assign({ ref: ref, className: cn('text-muted-foreground mt-4 whitespace-nowrap text-sm', className) }, props)));
});
TableCaption.displayName = 'TableCaption';
export { Table as BtwTable, TableHeader as BtwTableHeader, TableBody as BtwTableBody, TableFooter as BtwTableFooter, TableHead as BtwTableHead, TableRow as BtwTableRow, TableCell as BtwTableCell, TableCaption as BtwTableCaption, };
